<template>
  <Layout>
    <TableView slot="content" @action="action" @nextList="nextList" :columns="custColumns" :list="list" :data="custInfo"
      :server-total="total" minWidth="900px">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input @change="searchKeyword = $event.target.value" class="form-control form-control-solid w-350px ps-11"
          :placeholder="$t('조직명, 영문명, Cusr Abbr.')" title="조직명, 영문명, Cusr Abbr.">
      </div>
      <b-button variant="primary" v-b-modal.추가 v-text="$t('조직 추가')" @click="addClick" ></b-button>
    </TableView>
    
    <ModalForm @action="addAction" id="추가" title="조직 추가" :spec="custColumns" ref="addCust" @show="showAddMod" no-close-on-ok>
      <div class="d-flex justify-content-end">
        <b-input-group-append>
          <b-button v-b-modal.조직선택 variant="success" v-text="$t('목록')" />
        </b-input-group-append>
      </div>
      <b-form-group label="OFAC Check" label-cols='5'>
        <div class="form-check form-switch form-check-custom form-check-solid">
          <b-form-checkbox switch v-model="ofacCheckYn" />
        </div>
      </b-form-group>
    </ModalForm>

    <!-- 조직선택 모달 -->
    <b-modal id="조직선택" :title="$t('조직선택')" size="xl" @show="searchCustKeyword='';getSrcCustList(true)" centered modal-class="full" >
      <TableView :server-total="custTotal" :columns="custDetailColumns" :list="srcCustList" @action="selectAction" :actions="['선택']" @nextList="getSrcCustList()">
        <div class="d-flex align-items-center position-relative me-3" >
          <b-icon icon="search" />
          <input @change="searchCustKeyword = $event.target.value; getSrcCustList(true)" class="form-control form-control-solid w-250px ps-11" @keyup.enter.stop            
            :placeholder="$t('조직명, 영문명, Cust Abbr.')">
        </div>
      </TableView>
    </b-modal>  

    <ModalForm @action="selectAction" id="view" title="조직상세" :spec="custDetailColumns" :data="custDetail" />  
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    custInfo: {}, custDetail: {},
    newSel: {},
    list: [],
    srcCustList: [],
    total: 0, custTotal: 0,
    searchKeyword: '',
    searchCustKeyword: '',
    checked: false,
    ofacCheckYn: true,
    personInfoOpenYn: false,
    custAbbr:'',

    custColumns: [    // 조직관리 목록,    조직추가 spec
      { form: 1, key: 'custAbbr', label: 'Cust Abbr.', required, readonly:['추가'], style: { textAlign: 'center' } },
      { form: 2, key: 'custName', label: '조직명', required, readonly:['추가'], style: { textAlign: 'center' } },
      { form: 3, key: 'custFullName', label: '조직영문명', required, readonly:['추가'], style: { textAlign: 'center' } },
      { form: 4, key: 'registno', label: '사업자등록번호', readonly:['추가'], style: { textAlign: 'center' }, renderer: (r) => r.registno ? r.registno.f('registno') : '' },
      { form: 5, key: 'tel', label: '연락처', type: 'tel', readonly:['추가'], style: { textAlign: 'center' }, hide:['td'], renderer: (r) => r.tel ? r.tel.f('tel') : '' },
      { form: 6, key: 'fax', label: 'FAX', readonly:['추가'], style: { textAlign: 'center' }, hide:['td'], renderer: (r) => r.fax ? r.fax.f('tel') : '' },      
      { form: 7, key: 'gcifNo', label: 'GCIF', required, readonly:['추가'], style: { textAlign: 'center' } },
      { form: 8, key: 'ccifNo', label: 'CCIF', required, readonly:['추가'], style: { textAlign: 'center' } },      
      { form: 9, key: 'modUserNm', label: '최종수정자', readonly:['추가'], style: { textAlign: 'center' }, hide:['추가'] },
      { form: 10, key: 'modDt', label: '최종수정일', type:'datetime-local', readonly:['추가'], style: { textAlign: 'center' }, hide:['추가'] },
    ],
    custDetailColumns: [     // 조직추가 > 조직선택 List
      { form: 1, key: 'custAbbr', label: 'Cust Abbr.', style: { textAlign: 'center' } },
      { form: 2, key: 'custName', label: '조직명', style: { textAlign: 'center' } },
      { form: 3, key: 'custFullName', label: '조직영문명', style: { textAlign: 'center' } },      
      { form: 4, key: 'registno', label: '사업자등록번호', style: { textAlign: 'center' }, renderer: (r) => r.registno ? r.registno.f('registno') : '' },
      { form: 5, key: 'tel', label: '연락처', type:'tel', style: { textAlign: 'center' }, renderer: (r) => r.tel ? r.tel.f('tel') : '' },
      { form: 6, key: 'fax', label: 'FAX', style: { textAlign: 'center' }, renderer: (r) => r.fax ? r.fax.f('tel') : '' },
      { form: 7, key: 'gcifNo', label: 'GCIF', style: { textAlign: 'center' } },
      { form: 8, key: 'ccifNo', label: 'CCIF', style: { textAlign: 'center' } },
    ],
  }),
  created() { this.getList() },
  mounted() { },
  beforeDestroy() { },
  computed: {},
  watch: {
    searchKeyword() { this.getList() },
  },
  methods: {
    async action({ action, item, form }) {
      //조직 상세 페이지 이동
      if (!form && ['view'].includes(action)) return this.$go('cust?id='+item.custId);
      
      if (!form && !(await this.$alert(this.$t('[$] 조직을 $ 하시겠습니까?', [item.custName, action]), { confirm: true, title: action }))) return;
      form.custAbbr = this.custAbbr;
      form.ofacCheckYn = this.ofacCheckYn ? 'Y' : 'N';
      form.personInfoOpenYn = this.personInfoOpenYn ? 'Y' : 'N';
      const res = await this.$api(`adm/cust/${({ view:'selectCustList', 추가:'insertCust', 수정: 'updateCust', 선택: 'insertCust', 조직선택:'selectSrcCustList', 삭제: 'deleteCust' })[action]}`, form);
      await this.$alert(res.message);
      if (res.success) this.getList();
    },
    // 조직선택 Action
    async selectAction ({ item, action }) {   
      this.$refs.addCust.form = {};
      const { form, spec } = this.$refs.addCust;    // ref는 ModalForm.vue 에서 가져오는 data-form 이다.
      if (['view'].includes(action)) {
        return;
      } else if (['선택'].includes(action)) {
        this.custAbbr = item.custAbbr;
        for (const key in item) if (spec.some(s => s.key == key)) form[key] = item[key];  // item에 있는 key를 spec에 key와 비교해서 같다면 item의 key를 form key로 할당.                        
        this.$bvModal.hide('조직선택');
      }
    },
    async showAddMod() {
      this.custDetail = {};
      this.ofacCheckYn = true;
    },
    async addAction({ item, form }) {
      if(item) this.custInfo = item;
      form.custAbbr = this.custAbbr;
      form.ofacCheckYn = this.ofacCheckYn ? 'Y' : 'N';
      form.personInfoOpenYn = this.personInfoOpenYn ? 'Y' : 'N';
      const res = await this.$api(`adm/cust/insertCust`, form );
      await this.$alert(res.msg);
      if (res.success) {
        this.getList();
        this.$bvModal.hide('추가');
      }
    },
    nextList() {
      if (this.total > this.list.length) this.getList(this.list.length + 1);
    },
    /** 목록 데이터 수신 */
    async getList(firstIndex = 1) {
      const res = await this.$api('adm/cust/selectCustList', { firstIndex, searchKeyword: this.searchKeyword });
      this.list = firstIndex == 1 ? res.list : this.list.concat(res.cust);
      this.total = res.parameter.total;
    },
    /* 조직추가 > 목록 리스트 */
    async getSrcCustList(reset) {
      if(reset) this.srcCustList = [];
      const res = await this.$api('adm/cust/selectSrcCustList', { firstIndex:this.srcCustList.length+1, searchKeyword: this.searchCustKeyword });
      this.srcCustList.push(...res.list);
      this.custTotal = res.parameter.total;
    },
    async addClick() { this.custAbbr = '' },
  },
}
</script>
